import styled from 'styled-components';
import size from '../../../theme/mediaQueries';

export const Header = styled.header`
  grid-area: head;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.colors.background_dashboard};
  padding: 16px 24px;
  
  //later we'll have to change it to 16 120 I guess 
  @media (min-width: ${size.laptopL}){
    padding: 16px 24px;
  }
`;

export default { Header };
